define(['backbone', 'assets/js/modules/design/designFaceModel'], function(backbone, designFaceModel) {
    return backbone.Collection.extend({
        model: designFaceModel
    });
});
